// extracted by mini-css-extract-plugin
module.exports = {"main":"button-panel_main__1jtFB","btns":"button-panel_btns__2pqDj"};